import { createGlobalStyle } from 'styled-components';
import './shared/theme/antd.css'
import './shared/theme/global.css'

export const GlobalStyles = createGlobalStyle`
  
`;
